/**
 * Server-published cache version buckets. Each bucket version changes on the
 * backend whenever the underlying data changes; the client treats these as
 * opaque integers and only compares for equality/inequality.
 */
export type CacheBucket =
  | 'product'
  | 'category'
  | 'menu'
  | 'store'
  | 'inventory'
  | 'media.product'
  | 'media.menu'
  | 'media.store'
  | 'shipping'
  | 'addon';

export const KNOWN_BUCKETS: readonly CacheBucket[] = [
  'product',
  'category',
  'menu',
  'store',
  'inventory',
  'media.product',
  'media.menu',
  'media.store',
  'shipping',
  'addon'
] as const;

export type CacheVersionsMap = Partial<Record<CacheBucket, number>>;

export interface CacheVersionsResponse {
  status: boolean;
  message: string;
  data: { versions: CacheVersionsMap };
  errors: unknown;
  meta: unknown;
}
